export default __webpack_public_path__ + "static/media/point.a3aa846d.svg";